import { selectLocationState } from 'redux-first-router'
import { createBasicSelector } from 'util/redux'

const selectCurrentConversationId = createBasicSelector(
  selectLocationState,
  location => location && location.query && location.query.conversationId
)

export default selectCurrentConversationId
